module.exports = __webpack_public_path__ + "static/media/cicles.e5350582.jpg";